import * as React from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";
import authService from './AuthorizeService'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import { isUndefined } from "util";

const AuthorizationRoute = ({ component: Component, children, ...rest }: RouteProps) => {

    const [ready, setReady] = useState(false);
    const [authenticated, setAuthenticated] = useState<boolean>();
    const [mfaEnabled, setMfaEnabled] = useState<boolean>();
    const location = useLocation()
    
    const redirectUrl = useMemo(() => {
        const returnUrl = `${document.location.protocol}//${document.location.host}${location.pathname}`;
        return `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`
    }, [location.pathname])
    
    const redirectMfaUrl = useMemo(() => {
        const returnUrl = `${document.location.protocol}//${document.location.host}${location.pathname}`;
        return `${ApplicationPaths.IdentityEnableMfaPath}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`
    }, [location.pathname])

    const populateAuthenticationState = useCallback(async () => {
        setAuthenticated(await authService.isAuthenticated());
        setReady(true);
    }, [])

    const authenticationChanged = useCallback(async () => {
        setReady(false);
        setAuthenticated(false);
        await populateAuthenticationState();
    }, [populateAuthenticationState])
    
    useEffect(() => {
        const subscription = authService.subscribe(() => authenticationChanged());
        return () => authService.unsubscribe(subscription)
    }, [authenticationChanged])

    useEffect(() => {
        populateAuthenticationState();
    }, [populateAuthenticationState])

    useEffect(() => {
        authService.getUser().then(u => setMfaEnabled(u?.amr?.includes("mfa") || false))
    }, [])

    if (!ready) 
        return <div>Bezig met laden...</div>;

    if (!authenticated)
        return <Redirect to={redirectUrl} />

    if (typeof mfaEnabled !== 'undefined' && !mfaEnabled)
        return <div>
            <h3>Activeer 2-traps verificatie om deze pagina te raadplegen.</h3>
            <br />
            <a className="btn btn-primary" href={redirectMfaUrl}>2 traps verificatie configureren</a>
        </div>


    return <Route {...rest} component={(authenticated && Component) || undefined} >
        {(authenticated && children) || <Redirect to={redirectUrl} />}
    </Route>
}
export default AuthorizationRoute;